import { render, staticRenderFns } from "./menuCom.vue?vue&type=template&id=8c00f41c&scoped=true&"
import script from "./menuCom.vue?vue&type=script&lang=js&"
export * from "./menuCom.vue?vue&type=script&lang=js&"
import style0 from "./menuCom.vue?vue&type=style&index=0&id=8c00f41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c00f41c",
  null
  
)

export default component.exports